import PropTypes from 'prop-types';
import React, { Component } from 'react';
import getDisplayName from '../../utils/getDisplayName';

const defaults = {
  timeout: 2000,
  logEscapeHatch: () => {}
};

/*
 * Currently used by all 3 of our video section components (Facebook, Youtube, Internal/JW).
 * Encapsulates the logic of ensuring that `timeoutHandler` is fired after
 * a certain amount of time.
 */

export default (options = {}) => WrappedComponent => class extends Component {
  static displayName =
    `WithEscapeHatch(${getDisplayName(WrappedComponent)})`;

  static propTypes = {
    timeoutHandler: PropTypes.func
  };

  constructor(props, context) {
    super(props, context);
    this.options = {};
    Object.assign(this.options, defaults, options);
  }

  componentDidMount = this.setOrResetEscapeHatch;

  componentDidUpdate = this.setOrResetEscapeHatch;

  componentWillUnmount() {
    if (this.timeoutID) {
      window.clearTimeout(this.timeoutID);
    }
  }

  setOrResetEscapeHatch() {
    if (this.timeoutID) {
      window.clearTimeout(this.timeoutID);
    }
    if (!this.props.timeoutHandler) {
      return;
    }
    this.timeoutID = window.setTimeout(
      this.escapeHatch,
      this.options.timeout
    );
  }

  escapeHatch = () => {
    this.options.logEscapeHatch();
    this.props.timeoutHandler();
  }

  render() {
    return <WrappedComponent {...this.props} />;
  }
};
